<div class="effect">
  @switch (effect().type) { @case (typeNone) {
  <av-icon
    [attr.aria-label]="'Remove background effect' | translate"
    name="none"
  ></av-icon>
  } @case (typeBlur) {
  <av-icon
    [attr.aria-label]="'Blur background' | translate"
    name="background-blur"
  ></av-icon>
  } @case (typeImage) {
  <div class="fx-row fx-align-center fx-justify-center full-height">
    @if (url) {
    <img
      #image
      [attr.aria-label]="'Set photo as background' | translate"
      [src]="url"
      (error)="failed()"
    />
    } @if (!url) {
    <av-spinner mode="dark" size="xs"></av-spinner>
    }
  </div>
  } }
</div>
